@if (isOpen()) {
  <div class="overlay" (click)="close()"></div>
}

<aside class="chat-sidebar" [class.open]="isOpen()">
  @if (viewMode() === 'list') {
    <div class="chat-page-heading">
      Сообщения
      <button type="button" class="chat-top-bar__close chat-list-close" (click)="close()" aria-label="Закрыть">
        <span class="chat-top-bar__close-icon"></span>
      </button>
    </div>

    <div class="chat-list">
      <button type="button" class="chat-list__item chat-list__item--notifications" (click)="openNotifications()">
        <div class="chat-list__avatar chat-list__avatar--notifications">
          <img src="/assets/img/notifications-icon.png" alt="" />
        </div>
        <div class="chat-list__info">
          <div class="chat-list__title-row">
            <span class="chat-list__title">Уведомления</span>
          </div>
          <div class="chat-list__preview">{{ notificationsLastMessage() }}</div>
        </div>
        @if (notificationsPreview().unread > 0) {
          <span class="chat-list__unread">{{ notificationsPreview().unread > 99 ? '99+' : notificationsPreview().unread }}</span>
        }
        @if (formatListDate(notificationsPreview().lastMessageAt); as time) {
          <span class="chat-list__date">{{ time }}</span>
        }
      </button>

      @if (false) {
        <button type="button" class="chat-list__item chat-list__item--support" (click)="openSupport()">
          <div class="chat-list__avatar chat-list__avatar--support">
            <img src="/assets/img/support-chat.png" alt="" />
          </div>
          <div class="chat-list__info">
            <div class="chat-list__title-row">
              <span class="chat-list__title">Поддержка IQMarket</span>
              <img class="chat-list__title-icon" src="/assets/img/chat.png" alt="" />
            </div>
            <div class="chat-list__preview">{{ supportLastMessage() }}</div>
          </div>
          @if (supportPreview().unread > 0) {
            <span class="chat-list__unread">{{ supportPreview().unread > 99 ? '99+' : supportPreview().unread }}</span>
          }
          @if (formatListDate(supportPreview().lastMessageAt); as time) {
            <span class="chat-list__date">{{ time }}</span>
          }
        </button>
      }
    </div>
  } @else if (viewMode() === 'notifications') {
    <div class="chat-top-bar">
      <span class="chat-top-bar__title">Уведомления</span>
      <button type="button" class="chat-top-bar__close" (click)="close()" aria-label="Закрыть">
        <span class="chat-top-bar__close-icon"></span>
      </button>
    </div>

    <header class="chat-header chat-header--notifications">
      <button type="button" class="chat-header__back" (click)="goBack()" aria-label="Назад">
        <span class="chat-header__back-icon"></span>
      </button>
      <div class="chat-header__info">
        <div class="chat-header__name">Уведомления</div>
      </div>
      <img class="chat-header__notifications-icon" src="/assets/img/notifications-icon.png" alt="" />
    </header>

    <div class="notifications-page">
      @if (notificationsLoading() && notificationsFeed().length === 0) {
        <div class="notifications-empty">Загрузка...</div>
      } @else if (notificationsFeed().length === 0) {
        <div class="notifications-empty">Пока нет уведомлений</div>
      } @else {
        <div class="notifications-feed" #notificationsEl (scroll)="onNotificationsScroll($event)">
          @for (row of notificationsFeed(); track row.item.id) {
            @if (row.showDivider && row.item.createdAt) {
              <div class="notifications-divider">{{ row.item.createdAt | date: 'd MMMM' }}</div>
            }
            <div class="notification-item">
              <div class="notification-item__meta">
                <img class="notification-item__avatar" src="/assets/img/bot-avatar-icon.png" alt="" />
                <span class="notification-item__name">Бот IQMarket</span>
              </div>
              <div class="notification-item__bubble">
                @if (row.item.title) {
                  <div class="notification-item__title">{{ row.item.title }}</div>
                }
                <div class="notification-item__text">
                  @if (row.item.body) {
                    <div class="notification-item__body">{{ row.item.body }}</div>
                  }
                  @if (row.item.createdAt) {
                    <span class="notification-item__time">{{ row.item.createdAt | date: 'HH:mm' }}</span>
                  }
                </div>
              </div>
            </div>
          }
        </div>

        @if (showNotificationsScrollBtn()) {
          <button
            type="button"
            class="notifications-scroll-btn"
            (click)="scrollNotificationsToBottom()"
            aria-label="К новым уведомлениям"
          >
            <span class="notifications-scroll-btn__icon"></span>
          </button>
        }
      }
    </div>
  } @else if (dialog()) {
    <div class="chat-top-bar">
      <span class="chat-top-bar__title">Чат</span>
      <button type="button" class="chat-top-bar__close" (click)="close()" aria-label="Закрыть">
        <span class="chat-top-bar__close-icon"></span>
      </button>
    </div>

    <header class="chat-header" [class.chat-header--support]="isSupportDialog()">
      <button type="button" class="chat-header__back" (click)="goBack()" aria-label="Назад">
        <span class="chat-header__back-icon"></span>
      </button>

      @if (isSupportDialog()) {
        <img class="chat-header__support-icon" src="/assets/img/support-chat.png" alt="" />
        <div class="chat-header__info">
          <div class="chat-header__name">Чат с поддержкой IQMarket</div>
          <div class="chat-header__status">Онлайн 24 часа</div>
        </div>
      } @else {
        <div class="chat-header__info">
          <div class="chat-header__name">{{ participantName() }}</div>
          @if (infoTags().length) {
            <div class="chat-header__tags">
              @for (tag of infoTags(); track tag) {
                <span class="chat-header__tag">{{ tag }}</span>
              }
            </div>
          }
        </div>
      }
    </header>

    <div class="chat-messages" #messagesEl (scroll)="closeContextMenu()">
      @if (loading()) {
        <div class="chat-messages__status">Загрузка сообщений...</div>
      } @else {
        @for (msg of messages(); track msg.id) {
          @if (ticketLabel(msg); as ticket) {
            <div class="chat-ticket-line">{{ ticket }}</div>
          }
          <div
            class="chat-message"
            [id]="'chat-msg-' + msg.id"
            [class.chat-message--own]="isOwnMessage(msg)"
            [class.chat-message--editing]="editingMessage()?.id === msg.id"
            (contextmenu)="onMessageContextMenu($event, msg)"
          >
            @if (messageAuthor(msg) && !isOwnMessage(msg)) {
              <div class="chat-message__author">{{ messageAuthor(msg) }}</div>
            }
            <div class="chat-message__bubble">
              @for (quote of messageQuotes(msg); track quote.id || quote.linkId || $index) {
                <button type="button" class="chat-message__quote" (click)="scrollToQuoted(quote)">
                  @if (quoteAuthor(quote); as author) {
                    <div class="chat-message__quote-author">{{ author }}</div>
                  }
                  <div class="chat-message__quote-text">{{ quote.message?.text }}</div>
                </button>
              }
              @if (displayText(msg); as text) {
                <div class="chat-message__text">{{ text }}</div>
              }
              @if (msg.createdAt) {
                <div class="chat-message__time">{{ msg.createdAt | date: 'HH:mm' }}</div>
              }
            </div>
          </div>
        } @empty {
          <div class="chat-messages__status">Нет сообщений</div>
        }
      }
    </div>

    @if (editingMessage(); as editing) {
      <div class="chat-composer-banner chat-composer-banner--edit">
        <div class="chat-composer-banner__body">
          <div class="chat-composer-banner__title">Редактирование</div>
          <div class="chat-composer-banner__text">{{ editing.text }}</div>
        </div>
        <button type="button" class="chat-composer-banner__close" (click)="cancelEdit()" aria-label="Отменить редактирование">
          ×
        </button>
      </div>
    }

    <footer class="chat-input-wrapper">
      @if (quotingMessage(); as quoting) {
        <div class="quoting-message">
          <div class="quoting-message__author">{{ messageAuthor(quoting) }}</div>
          <div class="quoting-message__text">{{ quoting.text }}</div>
          <button type="button" class="quoting-message__close" (click)="cancelQuote()" aria-label="Отменить цитату">
            ×
          </button>
        </div>
      }

      <div class="chat-input">
        <div class="chat-input__attach" aria-hidden="true">
          <i class="icon-attachement"></i>
        </div>
        <div class="chat-input__group">
          <textarea
            [formControl]="messageControl"
            rows="1"
            placeholder="Введите сообщение"
            (keydown)="onComposerKeydown($event)"
          ></textarea>
          <button
            type="button"
            class="send-message-btn"
            [disabled]="!canSend()"
            (click)="send()"
            aria-label="Отправить"
          >
            @if (sending()) {
              <i class="icon-spinner" aria-hidden="true"></i>
            } @else {
              <i class="icon-send-message"></i>
            }
          </button>
        </div>
      </div>
    </footer>
  }
</aside>

@if (contextMenu(); as menu) {
  <div class="chat-context-menu-backdrop" (click)="closeContextMenu()" (contextmenu)="$event.preventDefault(); closeContextMenu()"></div>
  <ul
    class="chat-context-menu"
    [style.left.px]="menu.x"
    [style.top.px]="menu.y"
    (click)="$event.stopPropagation()"
    (contextmenu)="$event.preventDefault()"
  >
    @if (canEdit(menu.message)) {
      <li>
        <button type="button" (click)="startEdit(menu.message)">Редактировать</button>
      </li>
    }
    @if (menu.message.text) {
      <li>
        <button type="button" (click)="copyMessage(menu.message)">Копировать</button>
      </li>
    }
    @if (canQuote(menu.message)) {
      <li>
        <button type="button" (click)="startQuote(menu.message)">Цитировать</button>
      </li>
    }
    @if (canDelete(menu.message)) {
      <li>
        <button type="button" class="chat-context-menu__danger" (click)="removeMessage(menu.message)">
          Удалить
        </button>
      </li>
    }
  </ul>
}
